export const environment = {
  production: false,
  httpHost: 'https://dev.api.scouz.1d3a.com',
  firebase: {
    projectId: "scouz-dev",
    appId: "1:324341132554:web:f4fb78bbcd984a3649def3",
    storageBucket: "scouz-dev.appspot.com",
    apiKey: "AIzaSyCEue5mGKv3fSH25OTZ3yWesw2A8ypW1oc",
    authDomain: "scouz-dev.firebaseapp.com",
    messagingSenderId: "324341132554",
    measurementId: "G-P5P0VC1VS0",
    projectNumber: "324341132554",
    version: "2"
  },
  firebaseServiceUser: {
    email: "admin@scouz.1d3a.com",
    password: "9zwz0sB440yeHaMo"
  }
};
